/**
 * digitvision
 *
 * @category  digitvision
 * @package   Shopware\Plugins\DvsnFormBuilder
 * @copyright (c) 2026 digitvision
 */

import template from './dvsn-form-builder-form-detail.html.twig';
import './dvsn-form-builder-form-detail.scss';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.register('dvsn-form-builder-form-detail', {
    template,

    inject: [
        'repositoryFactory',
        'dvsnFormBuilderErrorHandlerService'
    ],

    mixins: [
        Mixin.getByName('placeholder'),
        Mixin.getByName('notification')
    ],

    metaInfo() {
        return {
            title: this.$createTitle()
        };
    },

    data() {
        return {
            form: null,
            isLoading: false,
            isSaveSuccessful: false,
            modalElement: null,
            modalElementIsNew: false,
            activeTab: 'base',
            responseTypes: [
                { id: 'content', value: 'content', label: this.$t('dvsn-form-builder-form.element.type.content') },
                { id: 'alert-success', value: 'alert-success', label: this.$t('dvsn-form-builder-form.element.type.alert-success') },
                { id: 'alert-info', value: 'alert-info', label: this.$t('dvsn-form-builder-form.element.type.alert-info') },
                { id: 'alert-warning', value: 'alert-warning', label: this.$t('dvsn-form-builder-form.element.type.alert-warning') },
                { id: 'alert-danger', value: 'alert-danger', label: this.$t('dvsn-form-builder-form.element.type.alert-danger') }
            ],
        };
    },

    created() {
        this.getForm();
    },

    computed: {
        elements() {
            return this.form.elements;
        },

        elementsColumns() {
            return this.getElementsColumns();
        },

        repository() {
            return this.repositoryFactory.create('dvsn_form_builder_form');
        },

        elementRepository() {
            return this.repositoryFactory.create('dvsn_form_builder_form_element');
        },

        criteria() {
            const criteria = new Criteria();

            criteria
                .addAssociation('elements')
                .addSorting(Criteria.sort('createdAt', 'ASC'));

            criteria.getAssociation('elements')
                .addSorting(Criteria.sort('position', 'ASC'));

            return criteria;
        },

        tabs() {
            return [{
                'name': 'base',
                'label': this.$t('dvsn-form-builder-form.detail.tabs.base'),
                'disabled': false
            }, {
                'name': 'elements',
                'label': this.$t('dvsn-form-builder-form.detail.tabs.elements'),
                'disabled': false
            }];
        }
    },

    methods: {
        getType(type) {
            return this.$t('dvsn-form-builder-form.element.type.' + type);
        },

        getForm() {
            this.isLoading = true;
            this.repository
                .get(this.$route.params.id, Shopware.Context.api, this.criteria)
                .then((entity) => {
                    this.form = entity;
                    this.isLoading = false;
                });
        },

        abortOnLanguageChange() {
            return this.repository.hasChanges(this.form);
        },

        saveOnLanguageChange() {
            return this.onClickSave();
        },

        onChangeLanguage() {
            this.getForm();
        },

        onDeleteElement(item) {
            const oldPosition = item.position;

            this.form.elements.remove(item.id);

            this.form.elements.forEach((element) => {
                if (element.position <= oldPosition) {
                    return;
                }

                element.position -= 1;
            });
        },

        onEditElement(element) {
            this.modalElement = element;
            this.modalElementIsNew = false;
        },

        onCreateElement() {
            let element = this.elementRepository.create(Shopware.Context.api);

            element.name = '';
            element.type = 'text';
            element.mandatory = false;

            this.modalElement = element;
            this.modalElementIsNew = true;
        },

        onModalElementCancel(name) {
            this.modalElement = null;
        },

        onModalElementSave() {
            if (this.modalElementIsNew === true) {
                this.modalElement.position = this.form.elements.length + 1;
                this.modalElement.createdAt = new Date();

                this.form.elements.push(this.modalElement);
            }

            this.modalElement = null;
        },

        getElementsColumns() {
            return [{
                property: 'position',
                dataIndex: 'position',
                label: this.$t('dvsn-form-builder-form.detail.card-elements.column-position'),
                allowResize: true,
                sortable: false
            }, {
                property: 'name',
                dataIndex: 'name',
                label: this.$t('dvsn-form-builder-form.detail.card-elements.column-name'),
                allowResize: true,
                sortable: false
            }, {
                property: 'type',
                dataIndex: 'type',
                label: this.$t('dvsn-form-builder-form.detail.card-elements.column-type'),
                allowResize: true,
                sortable: false
            }];
        },

        forceValidValues() {
            this.form.status = Boolean(this.form.status);
            this.form.name = (this.form.name === undefined || this.form.name === null) ? '' : this.form.name.trim();
            this.form.emailStatus = Boolean(this.form.emailStatus);
            this.form.emailRecipient = (this.form.emailRecipient === undefined || this.form.emailRecipient === null) ? '' : this.form.emailRecipient.trim();

            if (this.form.emailRecipient === '') {
                this.form.emailRecipient = null;
            }
        },

        validateValues() {
            if (this.form.name === '') {
                this.createNotificationError({
                    title: this.$t('dvsn-form-builder-form.detail.error-title'),
                    message: this.$t('dvsn-form-builder-form.detail.error-messages.invalid-name')
                });

                return false;
            }

            return true;
        },

        onClickSave() {
            this.forceValidValues();

            if (this.validateValues() === false) {
                return;
            }

            this.isLoading = true;
            this.isSaveSuccessful = false;
            this.repository
                .save(this.form, Shopware.Context.api, this.criteria)
                .then(() => {
                    this.getForm();
                    this.isLoading = false;
                    this.isSaveSuccessful = true;

                }).catch((exception) => {
                this.isLoading = false;
                this.createNotificationError({
                    title: this.$t('dvsn-form-builder-form.detail.error-message'),
                    message: exception
                });
            });
        },

        saveFinish() {
        },
    }
});
